import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";
import Landing from "@/pages/Landing";
import Shop from "@/pages/Shop";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import OrderSuccess from "@/pages/OrderSuccess";
import AdminDashboard from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/login" element={<Auth mode="login" />} />
              <Route path="/register" element={<Auth mode="register" />} />
              <Route path="/account" element={<Account />} />
              <Route path="/order/success" element={<OrderSuccess />} />
              <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
